// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5cfcb022","667":"e84bff77","977":"fdfdd5b0"}[chunkId] + ".chunk.js";
};